import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, isSelected, ...props }) => <>
  <TableCell size={'small'}><TextCell value={_.get(row, 'name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.join(_.compact(_.get(row, 'commercial_packages')), ',')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'info.model.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'start_zone.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'end_zone.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'parent_license.license_client_id')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'group.group_client_id')} /></TableCell>
</>

export default React.memo(Row)
